function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.7456 1.25702C14.8271 1.33828 14.8917 1.43482 14.9358 1.5411C14.98 1.64739 15.0027 1.76133 15.0027 1.8764C15.0027 1.99147 14.98 2.10541 14.9358 2.21169C14.8917 2.31798 14.8271 2.41451 14.7456 2.49578L2.4956 14.7434C2.3313 14.9077 2.10846 15 1.8761 15C1.64375 15 1.42091 14.9077 1.2566 14.7434C1.0923 14.5792 1 14.3564 1 14.1241C1 13.8917 1.0923 13.669 1.2566 13.5047L13.5066 1.25702C13.5879 1.17554 13.6844 1.11091 13.7907 1.0668C13.897 1.0227 14.011 1 14.1261 1C14.2412 1 14.3552 1.0227 14.4615 1.0668C14.5678 1.11091 14.6643 1.17554 14.7456 1.25702Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.25706 1.25702C1.17558 1.33828 1.11093 1.43482 1.06682 1.5411C1.02271 1.64739 1 1.76133 1 1.8764C1 1.99147 1.02271 2.10541 1.06682 2.21169C1.11093 2.31798 1.17558 2.41451 1.25706 2.49578L13.5071 14.7434C13.6714 14.9077 13.8942 15 14.1266 15C14.3589 15 14.5818 14.9077 14.7461 14.7434C14.9104 14.5792 15.0027 14.3564 15.0027 14.1241C15.0027 13.8917 14.9104 13.669 14.7461 13.5047L2.49606 1.25702C2.41478 1.17554 2.31823 1.11091 2.21192 1.0668C2.10562 1.0227 1.99166 1 1.87656 1C1.76147 1 1.64751 1.0227 1.5412 1.0668C1.4349 1.11091 1.33834 1.17554 1.25706 1.25702Z",
  fill: "white"
});

var SvgCloseIcon = function SvgCloseIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCloseIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/close-icon.a50d7030.svg";
export { ForwardRef as ReactComponent };